import request from '@/utils/request'

/**
 * 查询签到账户列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function querySignAccount(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/sign.querySignAccount',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
